// Nudge Remote Web Controller Logic

document.addEventListener('DOMContentLoaded', () => {
  const statusDot = document.getElementById('status-dot');
  const statusText = document.getElementById('status-text');
  const statusBadge = document.getElementById('status-badge');
  const infoBadge = document.getElementById('footer-info-badge');
  const infoText = document.getElementById('footer-info-text');
  const footerRoomId = document.getElementById('footer-room-id');
  
  const prevBtn = document.getElementById('prev-btn');
  const nextBtn = document.getElementById('next-btn');
  
  const prevRipple = document.getElementById('prev-ripple');
  const nextRipple = document.getElementById('next-ripple');

  const deckMetadata = document.getElementById('deck-metadata');
  const deckFavicon = document.getElementById('deck-favicon');
  const deckTitle = document.getElementById('deck-title');

  let heartbeatInterval = null;
  let watchdogInterval = null;
  let statsInterval = null;
  let lastHeartbeatTime = 0;

  let peer = null;
  let conn = null;
  let checkDataPCInterval = null;
  let checkMediaPCInterval = null;

  let clientStartTime = 0;
  let clientTimeline = [];
  let loggedFirstCandidate = { DataConnection: false, MediaConnection: false };

  // Step 1: Parse room ID from query parameter ?id=<id>
  const urlParams = new URLSearchParams(window.location.search);
  const roomId = urlParams.get('id');

  if (!roomId) {
    statusDot.className = 'dot dot-error';
    statusText.textContent = 'No ID';
    if (footerRoomId) footerRoomId.textContent = 'Missing ID';
    return;
  }

  if (footerRoomId) footerRoomId.textContent = roomId;

  const diagOverlay = document.getElementById('diagnostic-overlay');

  const consoleContainer = document.getElementById('web-console-container');
  const consoleLog = document.getElementById('web-console-log');
  const toggleConsoleBtn = document.getElementById('web-toggle-console-btn');
  const clearConsoleBtn = document.getElementById('web-clear-console-btn');
  let consoleVisible = false;

  function addLog(text) {
    console.log(`[Diagnostic] ${text}`);
    if (!consoleLog) return;
    const now = new Date();
    const timeStr = now.toTimeString().split(' ')[0] + '.' + String(now.getMilliseconds()).padStart(3, '0');
    
    const entry = document.createElement('div');
    entry.className = 'log-entry';
    
    const timeSpan = document.createElement('span');
    timeSpan.className = 'log-time';
    timeSpan.textContent = `[${timeStr}]`;
    
    const textSpan = document.createTextNode(text);
    
    entry.appendChild(timeSpan);
    entry.appendChild(textSpan);
    
    consoleLog.appendChild(entry);
    consoleLog.scrollTop = consoleLog.scrollHeight;
  }

  function addClientTimelineStep(name) {
    if (!clientStartTime) clientStartTime = Date.now();
    const elapsed = ((Date.now() - clientStartTime) / 1000).toFixed(2);
    const step = { name, elapsed: `T+${elapsed}s` };
    clientTimeline.push(step);
    
    addLog(`[Timeline] Step: ${name} (${step.elapsed})`);
    
    const timelineContainer = document.getElementById('web-timeline-container');
    const timelineList = document.getElementById('web-timeline-list');
    if (timelineContainer && timelineList) {
      if (statusText.textContent !== 'Connected') {
        timelineContainer.style.display = 'block';
      }
      
      timelineList.innerHTML = clientTimeline.map(s => `
        <div class="timeline-step">
          <span class="timeline-step-name">▶ ${s.name}</span>
          <span class="timeline-step-time">${s.elapsed}</span>
        </div>
      `).join('');
    }
  }

  function setupWebRTCLogging(pc, type) {
    addLog(`[${type}] RTCPeerConnection initialized. states - Connection: ${pc.connectionState}, ICE: ${pc.iceConnectionState}, Gathering: ${pc.iceGatheringState}`);
    
    pc.addEventListener('connectionstatechange', () => {
      addLog(`[${type}] Connection State: ${pc.connectionState}`);
      if (pc.connectionState === 'connected') {
        addClientTimelineStep(`${type} connected`);
      }
    });
    
    pc.addEventListener('iceconnectionstatechange', () => {
      addLog(`[${type}] ICE Connection State: ${pc.iceConnectionState}`);
      if (pc.iceConnectionState === 'failed' || pc.iceConnectionState === 'disconnected') {
        addLog(`[${type}] WARNING: ICE connection transient failure detected.`);
      }
    });
    
    pc.addEventListener('icegatheringstatechange', () => {
      addLog(`[${type}] ICE Gathering State: ${pc.iceGatheringState}`);
    });
    
    pc.addEventListener('signalingstatechange', () => {
      addLog(`[${type}] Signaling State: ${pc.signalingState}`);
    });
    
    pc.addEventListener('icecandidate', (event) => {
      if (event.candidate) {
        const cand = event.candidate;
        addLog(`[${type}] Gathered ICE candidate: ${cand.candidate.split(' ')[7] || cand.protocol} (${cand.type})`);
        
        if (!loggedFirstCandidate[type]) {
          loggedFirstCandidate[type] = true;
          addClientTimelineStep(`First ${type} ICE (${cand.type})`);
        }
      } else {
        addLog(`[${type}] ICE gathering completed.`);
        addClientTimelineStep(`${type} ICE complete`);
      }
    });
  }

  if (clearConsoleBtn) {
    clearConsoleBtn.addEventListener('click', () => {
      if (consoleLog) consoleLog.innerHTML = '';
    });
  }

  if (toggleConsoleBtn) {
    toggleConsoleBtn.addEventListener('click', () => {
      consoleVisible = !consoleVisible;
      if (consoleContainer) {
        consoleContainer.style.display = consoleVisible ? 'block' : 'none';
      }
      toggleConsoleBtn.textContent = consoleVisible ? 'HIDE LOGS' : 'SHOW LOGS';
      if (consoleVisible && consoleLog) {
        consoleLog.scrollTop = consoleLog.scrollHeight;
      }
    });
  }


  function updateDiagnosticOverlay(stage, done) {
    if (!diagOverlay) return;

    // Show overlay if we are not fully connected
    if (statusText.textContent !== 'Connected') {
      diagOverlay.style.display = 'flex';
    } else {
      // Hide after a brief delay once connected, so it looks very clean!
      setTimeout(() => {
        if (statusText.textContent === 'Connected') {
          diagOverlay.style.display = 'none';
        }
      }, 1000);
    }

    let el = null;
    if (stage === 1) el = document.getElementById('diag-client-peer');
    else if (stage === 2) el = document.getElementById('diag-client-target');
    else if (stage === 3) el = document.getElementById('diag-client-data');
    else if (stage === 4) el = document.getElementById('diag-client-video');

    if (el) {
      const icon = el.querySelector('.icon');
      if (done) {
        el.className = 'diagnostic-item done';
        if (icon) icon.textContent = '✔';
      } else {
        el.className = 'diagnostic-item';
        if (icon) icon.textContent = '⏳';
      }
    }
  }

  function resetDiagnostics() {
    if (!diagOverlay) return;
    diagOverlay.style.display = 'flex';
    document.querySelectorAll('.diagnostic-item').forEach(el => {
      el.className = 'diagnostic-item';
      const icon = el.querySelector('.icon');
      if (icon) icon.textContent = '⏳';
    });
  }

  // Connect / Reconnect function
  async function connectToHost() {
    // If already connected or connecting, clean up first to avoid resource leakages
    handleDisconnect();

    resetDiagnostics();
    
    clientStartTime = Date.now();
    clientTimeline = [];
    loggedFirstCandidate = { DataConnection: false, MediaConnection: false };
    
    addLog("Initializing PeerJS client peer...");
    addClientTimelineStep("Client start");

    statusDot.className = 'dot dot-connecting';
    statusText.textContent = 'Connecting...';

    // Show logs toggle button on start
    if (toggleConsoleBtn) {
      toggleConsoleBtn.style.display = 'block';
    }

    try {
      peer = new Peer(undefined, {
        config: {
          iceServers: []
        }
      });

      peer.on('open', (myPeerId) => {
        addLog(`Registered with signaling server. Anonymous Peer ID: ${myPeerId}`);
        addClientTimelineStep("Registered with signaling");
        statusText.textContent = 'Signaling...';
        
        updateDiagnosticOverlay(1, true); // Client Registered

        addLog(`Initiating connection handshake to host room ID: ${roomId}`);
        addClientTimelineStep("Initiated handshake");
        updateDiagnosticOverlay(2, true); // Contacting Host
        conn = peer.connect(roomId);

        // Polling to intercept RTCPeerConnection for DataConnection
        checkDataPCInterval = setInterval(() => {
          if (conn.peerConnection) {
            clearInterval(checkDataPCInterval);
            setupWebRTCLogging(conn.peerConnection, "DataConnection");
            startStatsPolling(conn);
          }
        }, 100);
        
        bindConnectionEvents(conn);
      });

      // Handle incoming WebRTC video stream calls from extension
      peer.on('call', (call) => {
        addLog("Incoming MediaConnection video stream call from extension...");
        addClientTimelineStep("Incoming MediaConnection");
        call.answer(); // Answer with no audio/video stream of our own (receiver only)
        
        // Polling to intercept RTCPeerConnection for MediaConnection
        checkMediaPCInterval = setInterval(() => {
          if (call.peerConnection) {
            clearInterval(checkMediaPCInterval);
            setupWebRTCLogging(call.peerConnection, "MediaConnection");
          }
        }, 100);

        call.on('stream', (remoteStream) => {
          addLog("WebRTC MediaStream video feed successfully received!");
          addClientTimelineStep("MediaStream received");
          updateDiagnosticOverlay(4, true); // Live Preview Feed

          const video = document.getElementById('preview-video');
          const previewContainer = document.getElementById('preview-container');
          if (video && previewContainer) {
            video.srcObject = remoteStream;
            previewContainer.style.display = 'block';
            video.play().catch(err => {
              addLog(`[MediaConnection] Autoplay stream failed, retrying on interaction: ${err.message}`);
            });
          }
        });
      });

      peer.on('error', (err) => {
        addLog(`[Peer] Warning/Error from PeerJS cloud: ${err.message || err} (Type: ${err.type})`);
      });

    } catch (err) {
      addLog(`Crash inside PeerJS initialization: ${err.message}`);
      handleDisconnect();
    }
  }

  function bindConnectionEvents(connection) {
    connection.on('open', () => {
      addLog(`DataConnection successfully established with Host!`);
      addClientTimelineStep("DataConnection established");
      
      statusDot.className = 'dot dot-connected';
      statusText.textContent = 'Connected';

      updateDiagnosticOverlay(3, true); // Link Established
      
      // Hide diagnostic and timeline overlays after a brief delay once fully connected
      setTimeout(() => {
        if (statusText.textContent === 'Connected') {
          if (diagOverlay) diagOverlay.style.display = 'none';
          const tc = document.getElementById('web-timeline-container');
          if (tc) tc.style.display = 'none';
        }
      }, 1500);
      
      prevBtn.disabled = false;
      nextBtn.disabled = false;

      // Start Mutual Heartbeats
      lastHeartbeatTime = Date.now();
      startHeartbeats(connection);
      startWatchdog();
      startStatsPolling(connection);
    });

    connection.on('data', (data) => {
      if (!data) return;

      if (data.type === 'heartbeat') {
        lastHeartbeatTime = Date.now();
        triggerHeartbeatPulse();
      } else if (data.type === 'metadata') {
        addLog(`Received target page metadata: "${data.title}"`);
        updateMetadataUI(data.title, data.favIconUrl);
      }
    });

    connection.on('close', () => {
      addLog('DataConnection closed by Host.');
      handleDisconnect();
    });

    connection.on('error', (err) => {
      addLog(`[DataConnection] Transient error: ${err.message || err}`);
    });
  }

  // 1Hz Heartbeat ping to host
  function startHeartbeats(connection) {
    if (heartbeatInterval) clearInterval(heartbeatInterval);
    heartbeatInterval = setInterval(() => {
      if (connection && connection.open) {
        connection.send({ type: 'heartbeat' });
      }
    }, 1000);
  }

  // Watchdog to detect lost connection
  function startWatchdog() {
    if (watchdogInterval) clearInterval(watchdogInterval);
    watchdogInterval = setInterval(() => {
      if (Date.now() - lastHeartbeatTime > 3500) {
        console.warn("[Remote] Heartbeat timed out. Closing link...");
        handleDisconnect();
      }
    }, 1000);
  }

  // WebRTC Stats polling to show room details and connection info in top pills
  function startStatsPolling(connection) {
    if (statsInterval) clearInterval(statsInterval);
    const poll = async () => {
      if (!connection || !connection.peerConnection) return;
      try {
        const stats = await connection.peerConnection.getStats();
        let remoteIp = '';
        let connType = '';
        const candMap = new Map();

         // First pass: extract all remote candidates directly from stats
         const remoteCandMap = new Map();
         stats.forEach(report => {
           if (report.type === 'remote-candidate') {
             const addr = report.address || report.ip || 'Unknown';
             const rType = report.candidateType === 'host' ? 'Local' : (report.candidateType === 'srflx' ? 'STUN' : (report.candidateType === 'relay' ? 'TURN' : report.candidateType || 'Unknown'));
             const key = `${addr}:${report.port}`;
             remoteCandMap.set(report.id, {
               address: addr,
               port: report.port,
               type: rType,
               selected: false,
               state: 'inactive',
               key: key
             });
           }
         });

         // Second pass: correlate candidate-pair statistics to assign nominate/attempting states
         stats.forEach(report => {
           if (report.type === 'candidate-pair') {
             const remoteCandId = report.remoteCandidateId;
             if (remoteCandId && remoteCandMap.has(remoteCandId)) {
               const cand = remoteCandMap.get(remoteCandId);
               const isSelected = report.selected || (report.nominated && report.state === 'succeeded');
               
               if (isSelected) {
                 cand.selected = true;
                 cand.state = 'succeeded';
                 remoteIp = cand.address;
                 connType = cand.type;
               } else if (report.state === 'checking' || report.state === 'in-progress') {
                 if (cand.state !== 'succeeded') {
                   cand.state = report.state;
                 }
               } else if (report.state === 'failed') {
                 if (cand.state !== 'succeeded' && cand.state !== 'checking' && cand.state !== 'in-progress') {
                   cand.state = 'failed';
                 }
               }
             }
           }
         });

         // Deduplicate by address:port and populate candMap
         remoteCandMap.forEach(cand => {
           const key = cand.key;
           if (!candMap.has(key) || cand.selected || (cand.state === 'checking' && !candMap.get(key).selected)) {
             candMap.set(key, {
               address: cand.address,
               port: cand.port,
               type: cand.type,
               selected: cand.selected,
               state: cand.state
             });
           }
         });

        if (infoBadge && infoText && connection.open && remoteIp) {
          infoText.textContent = `${remoteIp} (${connType})`;
          infoBadge.style.display = 'flex';
        }

        // Update the new premium live peer details card
        const detailsCard = document.getElementById('web-rtc-details-card');
        const candidatesList = document.getElementById('rtc-candidates-list');

        if (detailsCard && candidatesList) {
          const candidates = Array.from(candMap.values());
          
          if (candidates.length === 0) {
            candidatesList.innerHTML = '<div class="rtc-empty-placeholder">Gathering local & remote candidates...</div>';
          } else {
            candidatesList.innerHTML = candidates.map(cand => {
              const isActive = cand.selected;
              const isAttempting = cand.state === 'checking' || cand.state === 'in-progress';
              
              let statusLabel = '';
              let statusClass = '';
              if (isActive) {
                statusLabel = '● ACTIVE';
                statusClass = 'active';
              } else if (isAttempting) {
                statusLabel = '⚡ ATTEMPTING';
                statusClass = 'attempting';
              } else {
                statusLabel = `○ ${cand.state ? cand.state.toUpperCase() : 'INACTIVE'}`;
                statusClass = 'inactive';
              }
              
              const isMdns = cand.address.endsWith('.local') ? ' <span style="color: #f97316; font-size: 7.5px; font-weight: 750;">(mDNS)</span>' : '';
              return `
                <div class="rtc-candidate-row ${isActive ? 'active' : ''} ${isAttempting ? 'attempting' : ''}">
                  <span class="rtc-candidate-ip">${cand.address}:${cand.port}${isMdns}</span>
                  <span class="rtc-candidate-meta">
                    <span class="rtc-candidate-type">${cand.type}</span>
                    <span class="rtc-candidate-status ${statusClass}">${statusLabel}</span>
                  </span>
                </div>
              `;
            }).join('');
          }
        }
      } catch (err) {
        console.error('Stats poll failed:', err);
      }
    };

    // Run the first poll synchronously/immediately, then schedule the interval timer
    poll();
    statsInterval = setInterval(poll, 2000);
  }

  function handleDisconnect() {
    statusDot.className = 'dot dot-error';
    statusText.textContent = 'Offline';
    if (infoBadge) infoBadge.style.display = 'none';
    if (footerRoomId) footerRoomId.textContent = roomId || 'None';
    
    if (deckMetadata) deckMetadata.style.display = 'none';
    const previewContainer = document.getElementById('preview-container');
    if (previewContainer) previewContainer.style.display = 'none';

    prevBtn.disabled = true;
    nextBtn.disabled = true;

    if (heartbeatInterval) { clearInterval(heartbeatInterval); heartbeatInterval = null; }
    if (watchdogInterval) { clearInterval(watchdogInterval); watchdogInterval = null; }
    if (statsInterval) { clearInterval(statsInterval); statsInterval = null; }
    if (checkDataPCInterval) { clearInterval(checkDataPCInterval); checkDataPCInterval = null; }
    if (checkMediaPCInterval) { clearInterval(checkMediaPCInterval); checkMediaPCInterval = null; }

    if (conn) {
      try { conn.close(); } catch(e) {}
      conn = null;
    }
    if (peer) {
      try { peer.destroy(); } catch(e) {}
      peer = null;
    }
    
    // Hide diagnostic overlay and logs on disconnect
    if (diagOverlay) diagOverlay.style.display = 'none';
    const candidatesList = document.getElementById('rtc-candidates-list');
    if (candidatesList) {
      candidatesList.innerHTML = '<div class="rtc-empty-placeholder">Awaiting candidate gathering...</div>';
    }
    const timelineContainer = document.getElementById('web-timeline-container');
    if (timelineContainer) timelineContainer.style.display = 'none';
    if (toggleConsoleBtn) toggleConsoleBtn.style.display = 'none';
    if (consoleContainer) consoleContainer.style.display = 'none';
    consoleVisible = false;
  }

  function updateMetadataUI(title, favIconUrl) {
    if (!deckMetadata) return;

    if (title) {
      deckTitle.textContent = title;
    } else {
      deckTitle.textContent = "Nudge Presentation";
    }

    if (favIconUrl) {
      deckFavicon.src = favIconUrl;
      deckFavicon.style.display = 'block';
      deckFavicon.onerror = () => { deckFavicon.style.display = 'none'; };
    } else {
      deckFavicon.style.display = 'none';
      deckFavicon.src = "";
    }

    deckMetadata.style.display = 'flex';
  }

  // Trigger visual heartbeat pulse class
  function triggerHeartbeatPulse() {
    if (!statusDot) return;
    statusDot.classList.add('pulse-glow');
    setTimeout(() => {
      statusDot.classList.remove('pulse-glow');
    }, 150);
  }

  // Trigger local mechanical tap ripple
  function triggerRipple(element, ripple, event) {
    const rect = element.getBoundingClientRect();
    const x = (event.touches ? event.touches[0].clientX : event.clientX) - rect.left;
    const y = (event.touches ? event.touches[0].clientY : event.clientY) - rect.top;

    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    
    ripple.classList.add('ripple-active');
    setTimeout(() => {
      ripple.classList.remove('ripple-active');
    }, 300);
  }

  // Click handlers to trigger real-time key injections
  prevBtn.addEventListener('click', (e) => {
    const video = document.getElementById('preview-video');
    if (video && video.srcObject && video.paused) {
      video.play().catch(() => {});
    }

    if (conn && conn.open) {
      console.log('Sending Left Arrow keypress ping...');
      conn.send({ type: 'key', key: 'ArrowLeft' });
      triggerRipple(prevBtn, prevRipple, e);
    }
  });

  nextBtn.addEventListener('click', (e) => {
    const video = document.getElementById('preview-video');
    if (video && video.srcObject && video.paused) {
      video.play().catch(() => {});
    }

    if (conn && conn.open) {
      console.log('Sending Right Arrow keypress ping...');
      conn.send({ type: 'key', key: 'ArrowRight' });
      triggerRipple(nextBtn, nextRipple, e);
    }
  });

  // Prevent double-tap zoom gestures from mouse clicks
  prevBtn.addEventListener('dblclick', e => e.preventDefault());
  nextBtn.addEventListener('dblclick', e => e.preventDefault());

  // ==========================================
  // Visibility-based Lifecycle Management
  // ==========================================
  document.addEventListener('visibilitychange', () => {
    console.log(`[Remote] Visibility changed to: ${document.visibilityState}`);
    if (document.visibilityState === 'visible') {
      console.log("[Remote] Page became visible. Reconnecting portal...");
      connectToHost();
    } else {
      console.log("[Remote] Page went background. Disconnecting to preserve connection resources...");
      handleDisconnect();
    }
  });

  // Initial connection on page load
  connectToHost();
});
